/*
 * ARCHIVO GENERADO — no editar a mano.
 * Fuente: public/icons/*.svg · Regenerar con `npm run iconos`.
 */

/** Iconos disponibles. El nombre es el del archivo en `public/icons/`. */
export type NombreIcono =
  | 'apps'
  | 'caret-left'
  | 'caret-right'
  | 'check'
  | 'chevron-down'
  | 'close-icon'
  | 'download'
  | 'expand'
  | 'filter'
  | 'image-placeholder'
  | 'instagram'
  | 'menu'
  | 'play'
  | 'share'
  | 'tiktok'
  | 'toast-error'
  | 'toast-success'
  | 'toast-warning'
  | 'whatsapp'
  | 'youtube';

/** `viewBox` de cada glifo, tal como lo exporta Figma. */
export const VIEW_BOX: Record<NombreIcono, string> = {
  'apps': '0 0 24 24',
  'caret-left': '0 0 24 24',
  'caret-right': '0 0 24 24',
  'check': '0 0 24 24',
  'chevron-down': '0 0 20 20',
  'close-icon': '0 0 16 16',
  'download': '0 0 20 20',
  'expand': '0 0 24 24',
  'filter': '0 0 24 24',
  'image-placeholder': '0 0 21 26',
  'instagram': '0 0 16 16',
  'menu': '0 0 24 24',
  'play': '0 0 24 24',
  'share': '0 0 20 20',
  'tiktok': '0 0 14 16',
  'toast-error': '0 0 27 27',
  'toast-success': '0 0 27 27',
  'toast-warning': '0 0 27 27',
  'whatsapp': '0 0 22 22',
  'youtube': '0 0 16 12',
};
